class Storage {
	static saveToken(token){
		localStorage.setItem("JWT", token)
	}

	static getToken(){
		return localStorage.JWT
	}

	static logOut(){
		localStorage.clear()
	}

	static isLoggedIn(){
		return localStorage.JWT !== undefined
	}

	static setAsAdmin(){
		localStorage.setItem("admin", true)
	}

	static isAdmin(){
		return localStorage.admin !== undefined
	}

}

export default Storage;



// WEBPACK FOOTER //
// ./src/components/utils/Storage.js